import { Stack, Typography } from '@mui/material'
import type { SurveyElement } from '../MidYearSummary'
import { parseSurveyText } from '../../../../../../customComponents/survey/questions/components/parseSurveyText'

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryNumber = ({ element, answers }: Props): JSX.Element => {
  const answer = answers[element.name]

  return (
    <Stack gap={1}>
      <Typography variant='body1'>{parseSurveyText(element.title)}</Typography>
      {answer != null && answer !== ''
        ? <Typography variant='body1' fontWeight='bold'>{answer}</Typography>
        : <Typography variant='body1' color='text.disabled'>No response provided</Typography>
      }
    </Stack>
  )
}
